'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2; /* eslint-disable */

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _modules = require('redux/modules/modules');

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Module2App7 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module2,
    app: state.moduleData.data.module2.app7,
    profile: state.profile.data
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2App7, _Component);

  function Module2App7() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2App7);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2App7.__proto__ || (0, _getPrototypeOf2.default)(Module2App7)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 2,
      appId: 7,
      title: 'Home food environment - Cost saving shopping tips',
      isCompleted: _this.props.app.isCompleted || false,
      questions: [{
        choice: 'Coles fruit sticks',
        answer: '$8.50'
      }, {
        choice: 'Orange',
        answer: '$2.50'
      }, {
        choice: 'The Natural Confectionary Co \'Forbidden Fruits\'',
        answer: '$12.50'
      }, {
        choice: 'Carrots',
        answer: '$2.50'
      }, {
        choice: 'Uncle Toby\'s Muesli bars - multipack',
        answer: '$13.30'
      }, {
        choice: 'Pink lady apples',
        answer: '$3.50'
      }],
      answers: [{
        userAnswer: _this.props.app.colesVSOrange || ''
      }, {
        userAnswer: _this.props.app.confectionVSCarrots || ''
      }, {
        userAnswer: _this.props.app.muesliVSApples || ''
      }]
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _this.handleOnClick = function (module, modtype, item, event) {
      _this.props.changeItem(module, modtype, item, page);
    }, _this.handleUserChoice = function (index, event) {
      var obj = _this.state;
      obj.answers[index].userAnswer = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module2App7, [{
    key: 'getHeShe',


    /*
     * Returns he/she depending on child gender
     */
    value: function getHeShe() {
      if (this.props.profile.childGender === 'Male') {
        return 'he';
      }

      if (this.props.profile.childGender === 'Female') {
        return 'she';
      }

      return 'he/she';
    }

    /*
     * Handle when user finishes this module
     */


    /* *************** */
    /* HANDLE ON CLICK */
    /* *************** */

    // used to navigate to a resource item


    /*
     * Enter user answer
     */

  }, {
    key: 'renderQuestion',
    value: function renderQuestion(lessHealthyChoice, lessHealthyPrice, healthyChoice, healthyPrice, index) {
      var styles = require('../../Modules.scss');
      var choice1 = lessHealthyChoice;
      var answer1 = lessHealthyPrice;
      var choice2 = healthyChoice;
      var answer2 = healthyPrice;
      var iteration = index;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.FormGroup,
          { onChange: this.handleUserChoice.bind(this, iteration) },
          _react2.default.createElement(
            ReactBootstrap.Radio,
            { name: iteration, value: choice1, inline: true, checked: this.state.answers[iteration].userAnswer === choice1 },
            choice1
          ),
          ' ',
          _react2.default.createElement(
            ReactBootstrap.Radio,
            { name: iteration, value: choice2, inline: true, checked: this.state.answers[iteration].userAnswer === choice2 },
            choice2
          )
        ),
        this.state.answers[iteration].userAnswer === choice2 && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            { className: styles.greenText },
            'You are correct! ',
            choice2,
            ' is ',
            answer2,
            ', and ',
            choice1,
            ' is ',
            answer1,
            ' per kilogram!'
          )
        ),
        this.state.answers[iteration].userAnswer === choice1 && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            { className: styles.orangeText },
            'You are incorrect, ',
            choice2,
            ' is actually ',
            answer2,
            ' per kilogram and ',
            choice1,
            ' is ',
            answer1,
            ' per kilogram.'
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');
      var questions = this.state.questions;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 2'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Plan meals'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Buy fruit and vegetables that is in season'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'Legumes and beans are healthy cheap sources of protein'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'For more cost-saving tips check out the Cost Saving Tips under Module 2 Resources'
              )
            )
          ),
          _react2.default.createElement(
            'h4',
            null,
            'Which snack do you think is cheaper (compared by the kilogram)?'
          ),
          this.renderQuestion(questions[0].choice, questions[0].answer, questions[1].choice, questions[1].answer, 0),
          this.state.answers[0].userAnswer && this.renderQuestion(questions[2].choice, questions[2].answer, questions[3].choice, questions[3].answer, 1),
          this.state.answers[1].userAnswer && this.renderQuestion(questions[4].choice, questions[4].answer, questions[5].choice, questions[5].answer, 2),
          _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete }),
          _react2.default.createElement('div', { className: styles.spacer40 })
        )
      );
    }
  }]);
  return Module2App7;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func
}, _temp2)) || _class);

/* eslint-enable */

exports.default = Module2App7;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/App/App7.js
// module id = 1187
// module chunks = 0